import { API_BASE, ODATA_BASE } from "helpers/api_config";
import { gorselYuklemeParametreleri } from "helpers/gorselKucult";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import {
  optionalText,
  requiredText,
} from "helpers/validators";
import { useFormik } from "formik";
import { NameSurname } from "./contactlistCol";


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import { stripUnsupportedFields } from "helpers/odata_capabilities";
import axios from 'axios';
import jsPDF from "jspdf";
import "jspdf-autotable";

import CustomEditor from '../../../components/CustomEditor'; // CustomEditor.js yolunuza göre

import Dropzone from 'react-dropzone-uploader';
import { Base64 } from 'js-base64';
import moment from "moment";

import {
  getArticleDay as onGetArticleDay,
  addArticleDay as onAddArticleDay,
  updateArticleDay as onUpdateArticleDay,
  deleteArticleDay as onDeleteArticleDay,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";

import SayfaRehberi from "../../../components/Common/SayfaRehberi";
const ContactsList = props => {

  //meta title
  document.title = "Söz Sizde / Esnaf Aktüel | BERLİN ESNAF ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getFileName, setFileName] = useState('');


  const [getHtmlDataLong, setHtmlDataLong] = useState();

  const [getFileSubMedia, setFileSubMedia] = useState([]);

  const [getSubMediaID, setSubMediaID] = useState();

  const [getFileSubMediaAdd, setFileSubMediaAdd] = useState([]);
  const [getIsActive, setIsActive] = useState(false);
  const [getIsService, setIsService] = useState(false);
  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.ArticleDay_Title) || "",

      link: (contactEdit && contactEdit.ArticleDay_Desc) || "",
      // Konunun hangi bölümde görüneceği
      category: (contactEdit && contactEdit.ArticleDay_Category) || "SOZ_SIZDE",

    },
    validationSchema: Yup.object({
      title: requiredText("Başlık"),
      link: optionalText("Açıklama", { max: 5000 }),
      category: requiredText("Bölüm", { min: 2, max: 50 }),
    }),
    onSubmit: async values => {
      // ArticleDay_Category kolonu API'ye yayinlanana kadar gonderilemez:
      // API bilmedigi alanda 500 donuyor ve kayit hic eklenmiyor.
      const withCategory = async obj =>
        await stripUnsupportedFields(obj, ["ArticleDay_Category"]);

      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          ArticleDay_Title: values.title,
          ArticleDay_LongDesc: Base64.encode(getHtmlDataLong),
          Users_ID: getCategoryID,
          // Yeni gorsel secilmediyse kayitlidaki korunur.
          ArticleDay_Image: getFileName || contactEdit.ArticleDay_Image || null,
          ArticleDay_Desc: values.link,
          ArticleDay_Category: values.category,

        };
        dispatch(onUpdateArticleDay(await withCategory(updateUser)));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          ArticleDay_Title: values["title"],
          ArticleDay_LongDesc: Base64.encode(getHtmlDataLong),
          Users_ID: getCategoryID,      
          ArticleDay_Desc: values["link"],
          ArticleDay_Image: getFileName,
          ArticleDay_Category: values["category"],
        



        };
        // save new user
        dispatch(onAddArticleDay(await withCategory(newUser)));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.articleday,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);


  const [getCategoryID, setCategoryID] = useState(null);


  const [getCategory, setCategory] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Foto",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.ArticleDay_Image ? (
              <div className="avatar-xs">
                {cellProps.ArticleDay_Title != null ? <span className="avatar-title rounded-circle">
                  {cellProps.ArticleDay_Title.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <div>
                <img
                  className="rounded-circle avatar-xs"
                  src={'https://megasubdomain.stechomeyazilim.info/' + cellProps.ArticleDay_Image}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },
      {
        Header: "Bölüm",
        accessor: "ArticleDay_Category",
        filterable: true,
        Cell: cellProps => (
          <span className={"badge badge-soft-" + (cellProps.value === "ESNAF_AKTUEL" ? "info" : cellProps.value === "ESNAF_SITESI" ? "warning" : "primary")}>
            {cellProps.value === "ESNAF_AKTUEL" ? "Esnaf Aktüel" : cellProps.value === "ESNAF_SITESI" ? "Berlin Esnaf Sitesi" : "Söz Sizde"}
          </span>
        ),
      },
      {
        Header: "Başlık",
        accessor: "ArticleDay_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
     

      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">


              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  const _getAuthData = async () => {

    // Acilir listede yalniz ad gorunuyor; $select verilmezse OData butun
    // satiri (Users_Password, Users_MailAddress dahil) tarayiciya indiriyor.
    await axios.get(
      `${ODATA_BASE}/Users?$select=ID,Users_Name_Surname&$orderby=ID desc`
    )
      .then((res) => {
        setCategory(res.data.value || [])
      })


  }

 




  useEffect(() => {
    _getAuthData()
    


    if (users && !users.length) {
      dispatch(onGetArticleDay());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };




const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);
    setCategoryID(user.Users_ID);

    // MEVCUT GORSELI YUKLE.
    //
    // Iki hata birden vardi:
    //  1) Duzenle penceresi acildiginda `getFileName` bos kaliyor, kayitli
    //     gorsel gorunmuyordu.
    //  2) Daha kotusu: kaydederken `ArticleDay_Image: getFileName` yaziliyor.
    //     Kullanici yeni gorsel SECMEDEN yalnizca basligi duzeltip kaydettiginde
    //     bos deger gonderiliyor ve KAYITLI GORSEL SILINIYORDU.
    setFileName(user.ArticleDay_Image || '');

    // --- BU KISMI EKLE (Editör Dolsun) ---
    if (user.ArticleDay_LongDesc) {
      try {
        setHtmlDataLong(Base64.decode(user.ArticleDay_LongDesc));
      } catch (e) {
        setHtmlDataLong("");
      }
    } else {
      setHtmlDataLong("");
    }
    // -------------------------------------

    if (user.EditForm == 0) {
      setIsActive(false)
    } else {
      setIsActive(true)
    }

    if (user.EditForm == 0) {
      setIsService(false)
    } else {
      setIsService(true)
    }

    setIsEdit(true);
    toggle();
  };



  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };
  // NOT: burada `setContact(<liste>)` çağıran iki useEffect vardı.
  // `contact` SEÇİLİ SATIRI tutuyor; liste her değiştiğinde tüm dizi ile
  // eziliyor, dizide `.ID` olmadığı için silme sessizce hiçbir şey yapmıyordu.

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteArticleDay(contact.ID));
    }
    setContact(undefined);
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }
  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }


const _addMedia = () => {


    getFileSubMediaAdd.map((item, index) => {
      const newUser = {
        Education_SubItem_ID: getSubMediaID,
        EducationSubItem_Media_Type: item.fileType,
        EducationSubItem_Media_Link: item.fileName
      }

      axios.post(API_BASE + '/addSubEducationMediaDiz/send', newUser)

      dispatch(onGetArticleDay());

      toggleMedia();
    })
  }

  // Gorseller yuklenmeden once kucultulur (bkz. helpers/gorselKucult.js)
  const getUploadParams = gorselYuklemeParametreleri


  const handleChangeStatusBanner = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response)
          console.log("lnslkdf", result.file)
          setFileSubMediaAdd(oldArray => [{ fileName: result.file.filename, fileType: result.file.mimetype }, ...oldArray]);
        }
      }
    }
  }
  const handleChangeStatus = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)

        }
      }
    }
  }



  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Söz Sizde / Esnaf Aktüel Konuları" />
          <SayfaRehberi sayfa="articleday" />

          {/* Konunun hangi ekranda cikacagini "Bolum" alani belirliyor */}
          <div className="alert alert-info py-2 font-size-13">
            <i className="bx bx-info-circle align-middle me-1" />
            Buradan eklediğiniz konu, formdaki <strong>&quot;Bölüm&quot;</strong>
            {" "}seçimine göre uygulamada tek bir bölümde görünür:
            <strong> Söz Sizde</strong>, <strong> Esnaf Aktüel</strong> veya
            <strong> Berlin Esnaf Sitesi</strong>. Üç bölüm ayrı listelerdir.
            {(() => {
              const list = users || [];
              const bos = [
                { key: "ESNAF_AKTUEL", label: "Esnaf Aktüel" },
                { key: "ESNAF_SITESI", label: "Berlin Esnaf Sitesi" },
              ].filter(b => list.filter(x => x.ArticleDay_Category === b.key).length === 0);
              if (bos.length === 0) return null;
              return (
                <div className="mt-1">
                  Şu an <strong>{bos.map(b => b.label).join(" ve ")}</strong> bölümünde hiç konu
                  yok; uygulamada o bölüm boş görünür. Konu eklerken Bölüm alanından
                  ilgili bölümü seçmeniz yeterli.
                </div>
              );
            })()}
          </div>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddArticleDay={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={modalMedia} toggle={toggleMedia}>
                    <ModalHeader toggle={toggleMedia} tag="h4">
                      {!!isEdit ? "Düzenle" : "Medya Ekle"}
                    </ModalHeader>
                    <ModalBody>

                      <Row>
                        <Col xs={12}>


                          <div className="mb-3">
                            <label htmlFor="resume">Görsel</label>

                            {/* MEVCUT GORSEL
                                Duzenle penceresinde kayitli gorsel hic
                                gosterilmiyordu; kullanici neyin yuklu
                                oldugunu goremiyordu. Yeni dosya secilirse
                                bunun yerine o kaydedilir. */}
                            {getFileName ? (
                              <div className="d-flex align-items-center mb-2 p-2 border rounded bg-light">
                                <img
                                  src={'https://megasubdomain.stechomeyazilim.info/' + getFileName}
                                  alt=""
                                  style={{
                                    width: 84, height: 84, objectFit: 'cover',
                                    borderRadius: 6, border: '1px solid #e9edf2',
                                  }}
                                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                                />
                                <div className="ms-3 flex-grow-1">
                                  <div className="font-size-12 text-muted">Yüklü görsel</div>
                                  <div className="font-size-12 text-break">{getFileName}</div>
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => setFileName('')}
                                >
                                  Kaldır
                                </button>
                              </div>
                            ) : null}

                            <Dropzone
                              maxFiles={5}
                              getUploadParams={getUploadParams}
                              multiple={true}
                              onChangeStatus={handleChangeStatusBanner}
                              styles={{
                                dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                inputLabelWithFiles: { margin: '20px 3%' }
                              }}
                              canRemove={true}
                              PreviewComponent={Preview}
                              accept="image/*,video/*"
                            />
                          </div>

                        </Col>
                      </Row>
                      <Row>

                        {getFileSubMedia.map((item, index) => (
                          item.EducationSubItem_Media_Type == "video/mp4" ?
                            <div key={index}>
                              <video width="150" height="150" controls>
                                <source src={'https://megasubdomain.stechomeyazilim.info/' + item.EducationSubItem_Media_Link} type="video/mp4" />
                              </video>

                            </div> :

                            <div key={index}>
                              <img src={'https://megasubdomain.stechomeyazilim.info/' + item.EducationSubItem_Media_Link} alt="" className="avatar-sm" />
                            </div>
                        ))}



                        <Col>
                          <div className="text-end">
                            <button
                              onClick={() => _addMedia()}
                              type="submit"
                              className="btn btn-success save-user"
                            >
                              Medyaları Kaydet
                            </button>
                          </div>
                        </Col>
                      </Row>

                    </ModalBody>
                  </Modal>

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Makale Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>

                            <div className="mb-3">
                              <Label className="form-label">Kullanıcı Seçiniz</Label>
                              <Input
                                
                                type="select"
                                className="form-select"
                                defaultValue={getCategoryID}
                                onChange={(text) => _setChoiceCategory(text)}
                                value={
                                  getCategoryID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getCategory.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Users_Name_Surname}</option>
                                ))}

                              </Input>
                            </div>



                     
                            <div className="mb-3">
                              <Label className="form-label">Bölüm</Label>
                              <Input
                                name="category"
                                type="select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.category || "SOZ_SIZDE"}
                              >
                                <option value="SOZ_SIZDE">Söz Sizde</option>
                                <option value="ESNAF_AKTUEL">Esnaf Aktüel</option>
                                <option value="ESNAF_SITESI">Berlin Esnaf Sitesi</option>
                              </Input>
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Makale Başlığını Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>



                         




                            <div className="mb-3">
                              <Label className="form-label">Kısa Açıklama Giriniz</Label>
                              <Input
                                name="link"
                                label="link"
                                type="text"
                                placeholder="Kısa Açıklama Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.link || ""}
                                invalid={
                                  validation.touched.link &&
                                    validation.errors.link
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.link &&
                                validation.errors.link ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.link}
                                </FormFeedback>
                              ) : null}
                            </div>



                        







                            <div className="mb-3">
                              <Col xs={12} className="mb-3">
                                <label htmlFor="resume">Görsel</label>
                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatus}
                                  styles={{
                                    dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}

                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="image/*"
                                />

                              </Col>
                            </div>
<div className="mb-3">
  <Label className="form-label">Uzun Açıklama</Label>
  <CustomEditor
      data={getHtmlDataLong}
      onChange={(newData) => setHtmlDataLong(newData)}
  />
</div>

                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
